import React, { useState, useEffect } from 'react'
import Styles from './styles.module.sass'
import { useForm } from "react-hook-form"
import { InputTypeAndroid } from 'newComponents/Forms/InputType'
import { ModalError } from 'newComponents/Error/ErrorModal'
import {STAGE_DIRNAME } from 'constants/general'

export function TarjetaSears(props) {
    const {
        setAddCard,
        errorCode
    } = props

    let urlRFC
    if(STAGE_DIRNAME === "dev"){
        urlRFC = `https://release.sears.com.mx/c/rfc/`
    }else{
        urlRFC = `/c/rfc/`
    }

    // funciones para mostrar el modal
    const [showModal, SetShowModal] = useState(false);
    const showModalErrorCode = () => SetShowModal(true);
    const handleClose = () => SetShowModal(false);
    useEffect(()=>{
        if(errorCode <= 499){
            showModalErrorCode()
        }
        if(errorCode?.codMen?.indexOf('ERR') >= 0 ){
            showModalErrorCode()
        }
        
    },[errorCode])


    // banderas para mostrar ayuda inputs
    const [flagNumero, setFlagNumero] = useState(false);
    const [, setFlagTitular] = useState(false);

    const [datosTarjeta, setDatosTarjeta] = useState(false);
    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            numero: datosTarjeta.numero,
            rfc: datosTarjeta.rfc
        }
    });

    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);

    //- valores por default que muestra la tarjeta
    const [numeroCard, setNumeroCard] = useState();
    const [rfcT, setRfcT] = useState();

    //- valores para agregar tarjeta
    const [inputNumberCard, setInputNumberCard] = useState();
    const [inputRfcT, setInputRfcT] = useState();
    const [inputPhoneT, setInputPhoneT] = useState();

    useEffect(()=>{
        if(inputNumberCard){
            if(inputNumberCard.length != 0){
                setNumeroCard(inputNumberCard)
            }
        }else{
            setNumeroCard("**** **** ****")
        }
        
    },[inputNumberCard])

    // guarda la informacion enviada en el formulario
    const sendFormInformacionBancaria = data => {
        setDatos({
            "cardnumber": data.numero,
            "rfc": data.rfc.toUpperCase()
            //"phone_num": data.phone
        })
        SetReturnForm(true);
    };

    // al recibir data del formulario se guarda en variable datos bancarios
    useEffect(() => {
        if (returnForm) {
            setDatosTarjeta(datos);
            setAddCard(datos)
            SetReturnForm(false);
        }
    }, [returnForm])

    //- Validaciones de campos para agregar tarjeta
    const valNumero = {
        required: 'Campo obligatorio',
        minLength: {
            value: 12,
            message: 'Faltan dígitos. Deben ser al menos 12 dígitos'
        },
        maxLength: {
            value: 13,
            message: 'No debe contener más de 13 dígitos'
        },
        pattern: {
            value: /[0-9]{12,13}/,
            message: 'El formato de la tarjeta es inválido'
        }
    }
    const valRfc = {
        required: 'Campo obligatorio',
        minLength: {
            value: 9,
            message: 'El RFC al menos debe de contener 9 carácteres'
        },
        maxLength: {
            value: 10,
            message: 'No debe contener más de 10 carácteres'
        }
    }
    const resetErrors = (value) =>{
        let inputId = document.querySelector(`#${value} ~ .error`)
        if(inputId){
            let valu = value
            clearErrors(valu)
            reset({valu},{
                keepErrors: false, 
                keepDirty: true,
                keepIsSubmitted: false,
                keepTouched: false,
                keepIsValid: false,
                keepSubmitCount: false,
            });
        }
    }

    return (
        <>
            <div className={Styles?.boxCardFormDesk}>
                <div className={Styles?.cardDesk}>
                    <div className={Styles?.imaTarjetaDesk}>
                        <div className={Styles?.imgDesk} >
                            <div className={Styles?.numeroTarjeta}>
                                <span>{numeroCard}</span>
                            </div>
                            <div className={Styles?.titular}><span></span>
                            </div>
                        </div>
                    </div>
                </div>

                <form className={Styles?.formAgregarTarjetaSearsDesk} onSubmit={handleSubmit(sendFormInformacionBancaria)}>
                    
                    <InputTypeAndroid
                        type="text"
                        name="numero"
                        id="numero"
                        placeholder="Número de tarjeta"
                        placeholderInt="Ingresa el número"
                        refs={register(valNumero)}
                        autocomplete='numero'
                        setNumero={setInputNumberCard}
                        value={inputNumberCard}
                        errorMessage={errors.numero && errors.numero.message}
                        pattern={'number'}
                        minLength={12}
                        maxLength={13}
                        max="9999999999999"
                        click={() => resetErrors('numero')}
                    />

                    <InputTypeAndroid
                        type="text"
                        name="rfc"
                        id="rfc"
                        placeholder="RFC (sin homoclave)"
                        placeholderInt="Ingresa tu RFC"
                        refs={register(valRfc)}
                        autocomplete='rfc'
                        setNumero={setInputRfcT}
                        value={inputRfcT}
                        minLength={10}
                        maxLength={10}
                        errorMessage={errors.rfc && errors.rfc.message}
                        pattern={'textOnly'}
                        click={() => resetErrors('rfc')}
                    />
                    <p className={Styles?.linkRFC}>No conozco mi RFC,  <a href={urlRFC} target="_blank" className={Styles?.link}>¿Qué puedo hacer?</a></p>

                    <div className={Styles?.boxBtnGuardarSearsDesk}>
                        <button className={Styles?.btnGuardarCard}>Registrar</button>
                    </div>
                </form>
            </div>
            {showModal &&
                <ModalError errorCode={errorCode} section={'addCardSears'} handleClose={handleClose} />
            }
        </>
    )
}